import { TranslateService } from '@ngx-translate/core';
import DateBox from 'devextreme/ui/date_box';
import { custom } from 'devextreme/ui/dialog';
import DropDownBox from 'devextreme/ui/drop_down_box';
import NumberBox from 'devextreme/ui/number_box';
import Scrollable from 'devextreme/ui/scroll_view/ui.scrollable';
import SelectBox from 'devextreme/ui/select_box';
import TextArea from 'devextreme/ui/text_area';
import TextBox from 'devextreme/ui/text_box';

export interface Dialog {
  hide: (value: boolean) => void;
  show: () => Promise<Click>;
}

export interface Click {
  confirm: boolean;
}

export function getDomainName(): string {
  const domains = window.location.hostname.split('.');
  if (domains && domains.length > 1) {
    return window.location.host;
  } else {
    return 'dev10-ref.clinicmaster.com'; // For Dev
    // return 'myaccountqa.clinicmaster.com'; // For Addatech Dev
  }
}

export function createConfirmDialog(translateService: TranslateService): Dialog {
  return custom({
    messageHtml: translateService.instant('message.user_idle_message'),
    buttons: [
      {
        text: translateService.instant('actions.continue'),
        onClick: () => ({ confirm: true }),
      },
      {
        text: translateService.instant('actions.sign_out'),
        onClick: () => ({ confirm: false }),
      },
    ],
    showTitle: false,
    dragEnabled: false,
  });
}

export function setDefaultOptions(): void {
  NumberBox.defaultOptions({
    options: {
      stylingMode: 'outlined', //   'underlined'
    },
  });
  TextArea.defaultOptions({
    options: {
      stylingMode: 'outlined', //   'underlined'
    },
  });
  DateBox.defaultOptions({
    options: {
      stylingMode: 'outlined', //   'underlined'
    },
  });
  SelectBox.defaultOptions({
    options: {
      stylingMode: 'outlined', //   'underlined'
    },
  });
  DropDownBox.defaultOptions({
    options: {
      stylingMode: 'outlined', //   'underlined'
    },
  });
  TextBox.defaultOptions({
    options: {
      stylingMode: 'outlined', //  'filled', 'underlined'
    },
  });
  Scrollable.defaultOptions({
    options: {
      showScrollbar: 'onHover',
    },
  });
}
